var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"chatroom"},[_c('Loading',{attrs:{"loading":_vm.loading}}),_c('ChatHeaderBar'),_c('ChatBody',{staticClass:"flex-fill",attrs:{"unreadCount":_vm.unreadCount,"chat":_vm.chat}}),(this.chat.chat_type == 'schedule_change')?_c('ChatScheduleButtons',{attrs:{"chat":_vm.chat}}):_vm._e(),_c('ChatInput',{staticClass:"flex-wrap"})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }